module.exports = __webpack_public_path__ + "img/amsFA3.eb1dfd5a.png";